import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import NewsListItem from "./news-list-item";
import Pagination from "Pagination";
import LocaleStrings from "Languages";

class NewsList extends Component {
  renderList() {
    var items = _.map(this.props.news.data, (newsitem) => (
      <NewsListItem key={newsitem.newsid} newsitem={newsitem} />
    ));
    return items;
  }

  render() {
    return (
      <div className="sponsor-content">
        <table className="table sponsor-table">
          <thead>
            <tr>
              <th style={{ width: "10%" }}>{LocaleStrings.news_th_image}</th>
              <th>{LocaleStrings.news_th_title}</th>
              <th>{LocaleStrings.news_th_action}</th>
            </tr>
          </thead>
          <tbody className="tbody-background">{this.renderList()}</tbody>
        </table>
        {/* <Pagination
          paginationCallback={this.props.paginationCallback}
          items={this.props.news}
          show={this.props.search === ""}
        /> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    news: state.news,
  };
}

export default connect(mapStateToProps)(NewsList);
